import { createAsyncActionTypes } from 'conversations-async-data/async-action/createAsyncActionTypes';
export const CAPABILITIES_DATA_FETCH = createAsyncActionTypes('CAPABILITIES_DATA_FETCH');